<template>
    <div class="splash-background" v-show="store.state.currentScreen==='splash-dialog'">
        <div class="b3-modal" id="splash-dialog" v-show="store.state.currentScreen==='splash-dialog'">
            <img id="splash-image" src="https://beadographer.com/wp-content/uploads/2021/02/new_butterfly1.png" alt="photo of beads">
            <h1 id="app-title">{{ t('splash screen title', 'Beadographer') }}</h1>
            <div id="lite-message" v-if="!store.state.loggedIn">
                {{ t('free version', 'Free Version') }}
            </div>
            <div v-else class="spacer"></div>
            <transition name="fade">
                <div id="splash-buttons" v-if="store.state.startedApp">
                    <button
                        id="new-project-button"
                        class="big-button"
                        :class="hasClicked ? 'fancyEffect' : ''"
                        @click="startBeading"
                    >
                        {{ mainButtonMessage }}
                    </button>
                </div>
            </transition>
            <p id="loading" v-if="!store.state.startedApp">{{ t('loading message', 'Loading...' )}}</p>
            <div id="free-version-message" v-if="!store.state.loggedIn">
                <div id="free-version-text">
                    <span>{{ t('not logged in message', 'Welcome to the free version of Beadographer!') }}</span>
                </div>
                <div id="login-buttons">
                    <a class="button" href="https://beadographer.com/login">{{ t('log in button', 'Log in') }}</a>
                    <a class="button" href="https://beadographer.com/about">{{ t('learn more button', 'Learn more') }}</a>
                </div>
            </div>
            <p
                id="loading-error"
                v-if="store.state.showLoadingErrorMessage"
            >
                {{ t('app database opening error message', 'Error: Failed to open database. Beadographer will not work in Private Browsing Mode.') }}
            </p>
        </div>
        <div id="version-number">{{ 'v' + versionNumber }}</div>
    </div>
</template>

<script>
import { versionNumber } from '../myapp/src/core/environment.js';
import { start } from '../myapp/src/core/start.js';

export default {
    name: 'SplashScreen',
    data() {
        return {
            versionNumber,
            hasClicked: false,
            mainButtonMessage: this.t('start beading button', 'Start Beading')
        }
    },
    methods: {
        startBeading() {
            if (this.hasClicked) return;
            this.hasClicked = true;
            this.mainButtonMessage = this.t('one moment', 'One Moment...');
            start.beading();
        }
    }
}
</script>

<style lang="scss">
@import '../assets/colors.scss';

    .splash-background {
        background-color: $b_theme_light;
        position: absolute;
        height: 100%;
        width: 100%;
    }
    #splash-dialog {
        top: 10%;
        text-align: center;
        background-color: $b_theme;
        padding: 30px;
        border-radius: 5px;
        box-shadow: 10px 10px 0px $b_theme_hover;
        .fancyEffect {
            opacity: 0.5;
        }
        .spacer {
            height: 15px;
        }
        h1 {
            color: white;
            margin-bottom: 15px;
        }
    }

    #splash-image {
        border-radius: 5px;
        width: 200px;
        border: solid white 14px;
    }

    #app-title {
        font-family: Vollkorn;
        font-size: 40px;
    }

    #lite-message {
        color: white;
        font-family: Vollkorn;
        margin-bottom: 18px;
    }

    #new-project-button {
        margin-bottom: 35px;
    }

    #free-version-message {
        color: white;
        text-align: center;
        width: 240px;
        margin: auto;
        padding: 20px;
        background-color: $b_theme_hover;
        border-radius: 5px;
    }

    #free-version-text {
        margin-bottom: 10px;
    }

    #login-buttons a {
        background-color: $off_white;
        color: black;
        margin: 0 7px;
        &:hover {
            background-color: $medium_grey;
        }
    }

    #version-number {
        color: white;
        margin-bottom: 15px;
        position: absolute;
        bottom: 10px;
        left: 20px;
    }

</style>